<template>
  <b-container>
    <h1>{{ $t("tracking.cargoExpenseOccurrence.edit") }}</h1>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />

    <b-form @submit.prevent="save">
      <b-row class="mb-3 ml-0">
        <router-link :to="getUrlBackToList">
          <b-button size="sm">{{ $t("geral.backtolist") }}</b-button>
        </router-link>
      </b-row>

      <b-row>
        <b-col>
          <cargo-expense-occurrence-crud-data
            :model="model"
            :modelstate="modelstate"
            :readonly="false"
            class="mb-4"
          >
          </cargo-expense-occurrence-crud-data>
        </b-col>
      </b-row>
      

      <b-row>
        <b-col>
          <b-button type="submit" :disabled="submitted">
            {{ $t("geral.save") }}
          </b-button>
        </b-col>
      </b-row>
    </b-form>
    <div>
      <!-- {{model}} -->
    </div>
  </b-container>
</template>

<script>
export default {
  name: "CargoExpenseOccurrenceEdit",
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    CargoExpenseOccurrenceCrudData: () =>
      import(
        "@/components_rms/trackingShippingCompany/cargoExpenseOccurrence/CargoExpenseOccurrenceCrudData.vue"
      ),
    
  },
  props: {
    id: String,
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Ocorrência criada com sucesso",
      },
      submitted: false,
      modelstate: {},
      model: {
        sequenceNumber: 0,
        description: "",
        id: 0,
        companyId: 0,
        profiles: "",
        occurrenceTypeNext: "",
        permissions: 0,
        customFields: [],
        customField: 0
      },
    };
  },
  mounted() {
    this.loadData();
  },
  computed: {
    canEdit() {
      if (!this.model) {
        return false;
      }
      return true;
    },
    canSubmit() {
      if (this.submitted) {
        return true;
      }
      if (!this.canEdit) {
        return true;
      }
      return false;
    },
    getUrlBackToList() {
      return `../../cargoExpenseOccurrence/list`;
    },
    getUrlOccurrenceTypeList() {
      if (this.companyId) {
        return `/v1/cargoExpense/occurrence/get/${this.id}/${this.companyId}`;
      }
      return `/v1/cargoExpense/occurrence/get/${this.id}`;
    },
  },

  methods: {
    async loadData() {
      console.log(this.getUrlOccurrenceTypeList);
      this.$api
        .get(this.getUrlOccurrenceTypeList)
        .then((response) => {
          // console.log("entrou");
          // console.log(response.data);
          let model = response.data;
          this.model = model;
          console.log(model);
          window.scrollTo(0, 0);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            console.log(response.data);
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            if (error.response) {
              if (error.response.status == 400) {
                console.log(response.data);
                this.modelstate = error.response.data.errors;
              }
            }
            this.alert.error = error.message;
            this.$refs.danger.show();
            window.scrollTo(0, 0);
          }
          
        });
    },

    save() {
      this.submitted = true;

      this.$api
        .post(`/v1/cargoExpense/occurrence/edit/${this.model.id}`, this.model)
        .then((response) => {
          console.log("response.data");
          console.log(response.data);
          this.model = response.data;
          this.$forceUpdate();
          this.$refs.alert.show();
          this.modelstate = {};
          this.submitted = false;
        })

        .catch((error) => {
          console.log("error");
          console.log(error);
          this.submitted = false;
          this.modelstate = {};

          if (error.response) {
            console.log(error.response);
            if (error.response.status == 400) {
              this.modelstate = error.response.data.errors;
              this.alert.error = error.message;
              this.$refs.danger.show();
            } else if (error.response.status == 500) {
              this.alert.error = error.response.data;
              this.$refs.danger.show();
            } else {
              this.alert.error = error.message;
              this.$refs.danger.show();
            }
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
    
  },
  watch: {
    stateId() {
      this.loadData();
    },
  },
};
</script>
